import React from 'react';
import weddingCommission from '../../images/commission_1.jpg';
import giftCommission from '../../images/commission_2.jpg';
import { Helmet } from "react-helmet";

class CommissionsPage extends React.Component {
    render() {
        return (
            <section className="container commissions">
                <Helmet>
                    <title>Commissions | Ailsa Lyn Artist</title>
                    <meta name="description" content="Ailsa Lyn personalised commissions" />
                    <meta property="og:title" content="Ailsa Lyn Artist - Commissions" />
                    <meta property="og:url" content="https://ailsalyn.co.uk/commissions" />
                    <meta property="og:description" content="Ailsa Lyn personalised commissions" />
                </Helmet>

                <div className="row justify-content-center">
                    <p className="col-12 col-md-10 lead">I can produce Commissions of Watercolour and Hand-Painted paper Collages that are tailored to you. These pieces make the ideal personalised gift for weddings and special events.</p>
                </div>

                <div className="commissions-list">
                    <div className="row commission justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <img className="img-fluid" title="wedding gift collage" src={weddingCommission} />
                        </div>
                        <p className="col-12 col-md-4">This piece, commissioned as a wedding present. Includes collaged information from the wedding couple's Order of Service. Including the bride and groom's names, other members of the wedding party and pieces of associated music from the marriage ceremony.</p>
                    </div>
                    <div className="row commission justify-content-center align-items-center">
                        <div className="col-12 col-md-6 order-1 order-md-2">
                            <img className="img-fluid" title="Christmas gift collage" src={giftCommission} />
                        </div>
                        <p className="col-12 col-md-4 order-2 order-md-1">This piece is a personalised Christmas gift commission, from parents to their son of his home.</p>
                    </div>
                </div>

            </section>
        );
    }
}

export default CommissionsPage;



// WEBPACK FOOTER //
// ./src/components/commissions/CommissionsPage.js